import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["menu", "menuIcon", "closeIcon"];

  connect() {
    // Initialize - make sure menu icon is visible and close icon is hidden
    this.menuIconTarget.classList.remove("hidden");
    this.closeIconTarget.classList.add("hidden");
  }

  toggle() {
    // Toggle the mobile menu visibility
    this.menuTarget.classList.toggle("hidden");

    // Toggle icon visibility
    this.menuIconTarget.classList.toggle("hidden");
    this.closeIconTarget.classList.toggle("hidden");
  }
}
